/* eslint-disable camelcase */
import jwtDecode from "jwt-decode";

export default (token: string | null) => {
  if (!token) {
    return undefined;
  }

  let decoded;
  try {
    decoded = jwtDecode(token);
  } catch {
    return undefined;
  }

  const { poll_token: pollToken, exp, organization_id: organizationId } = decoded as {
    poll_token?: string;
    exp?: number;
    organization_id?: string;
  };

  return {
    pollToken,
    exp,
    organizationId,
  };
};
